"use client"
import { Box, Container } from "@mui/material"
import { PricingFAQ } from "@/app/components/pricing/PricingFAQ"
import { Hero } from "@/app/components/pricing/Hero"
import { PricingSection } from "@/app/components/pricing/PricingSection"
import { TrustBadges } from "@/app/components/TrustBadges"
import { planJsonLd } from "./jsonld"

export default function Pricing() {
    return (
        <Container>
            <script
                key="structured-data"
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(planJsonLd),
                }}
            />
            <Hero />
            <Box sx={styles.trustBadgesContainer}>
                <TrustBadges />
            </Box>
            <PricingSection />
            <PricingFAQ />
        </Container>
    )
}

const styles = {
    trustBadgesContainer: {
        mb: { xs: 8, md: 12 },
    },
}
